
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 18.4C21 18.8243 20.8276 19.2313 20.5207 19.5314C20.2138 19.8314 19.7976 20 19.3636 20H4.63636C4.20237 20 3.78616 19.8314 3.47928 19.5314C3.1724 19.2313 3 18.8243 3 18.4L3 8C3 7.57565 3.1724 7.16869 3.47928 6.86863C3.78616 6.56857 4.20237 6.4 4.63636 6.4H7.90909L9.54545 4H14.4545L16.0909 6.4H19.3636C19.7976 6.4 20.2138 6.56857 20.5207 6.86863C20.8276 7.16869 21 7.57565 21 8V18.4Z","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 15.5C13.3807 15.5 14.5 14.3807 14.5 13C14.5 11.6193 13.3807 10.5 12 10.5C10.6193 10.5 9.5 11.6193 9.5 13C9.5 14.3807 10.6193 15.5 12 15.5Z","stroke":"#10001F","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    